import { ActivityIngredient } from '@apps/main/modules/recipe/ingredients';

import type {
  ExposedActivityIngredient,
  ExposedSelectedTicketInfo,
  IngredientId,
  OldExposedActivityIngredient,
} from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';

export function createExposedActivityIngredient(
  activityIngredient: ActivityIngredient
): ExposedActivityIngredient {
  const { code, offset, tickets } = activityIngredient;

  return {
    ingredientType: IngredientType.Activity,
    code,
    offset,
    tickets: tickets.map((selectedTicket) => {
      const { rateId, ageRangeId, quantity, timeSlotId, getQuantityFromPax } =
        selectedTicket;
      const decodedSelectedTicketInfo: ExposedSelectedTicketInfo = {
        rateId,
        ageRangeId,
        quantity,
        timeSlotId,
        getQuantityFromPax,
      };

      return decodedSelectedTicketInfo;
    }),
  };
}

export function createActivityIngredient(
  exposedActivityIngredient:
    | ExposedActivityIngredient
    | OldExposedActivityIngredient,
  parentIngredientId: IngredientId
): ActivityIngredient {
  const { code, offset, tickets } =
    exposedActivityIngredient as ExposedActivityIngredient;

  // Backwards Compatibility
  const { selectedDateOffset, selectedTickets } =
    exposedActivityIngredient as OldExposedActivityIngredient;

  const activityIngredient = new ActivityIngredient(code, parentIngredientId);
  activityIngredient.offset = offset ?? selectedDateOffset;
  activityIngredient.tickets = (tickets ?? selectedTickets).map(
    (selectedTicket) => {
      const { rateId, ageRangeId, quantity, timeSlotId, getQuantityFromPax } =
        selectedTicket;
      return {
        rateId,
        ageRangeId,
        quantity,
        timeSlotId,
        getQuantityFromPax,
      };
    }
  );

  return activityIngredient;
}
